import React from 'react';
import HabitTracker from './pages/HabitTracker';
import './App.css';

function App() {
  return (
    <div className="App">
      <HabitTracker />
    </div>
  );
}

export default App;
